export default __webpack_public_path__ + "static/media/BRAIN_NEXT_ICONA.421c7cbd.svg";